import { CampaignPacing } from '../types/Campaign';

const CampaignPacingUtils = {
    identifyPacing: (percentage: number): CampaignPacing => {
        if (percentage <= 90) {
            return CampaignPacing.UNDERPACING;
        } else if (percentage > 90 && percentage <= 97) {
            return CampaignPacing.SLIGHTLY_BEHIND_SCHEDULE;
        } else if (percentage > 97 && percentage <= 105) {
            return CampaignPacing.ON_TRACK;
        }

        return CampaignPacing.OVERPACING;
    },
    getPacingColor: (percentage: number): 'error' | 'success' | 'warning' => {
        switch (CampaignPacingUtils.identifyPacing(percentage)) {
            case CampaignPacing.SLIGHTLY_BEHIND_SCHEDULE:
                return 'warning';
            case CampaignPacing.ON_TRACK:
                return 'success';
            // case CampaignPacing.UNDERPACING:
            // case CampaignPacing.OVERPACING:
            default:
                return 'error';
        }
    },
};

export default CampaignPacingUtils;
